// extracted by css-extract-rspack-plugin
export default {"labels":"_hPDVO","label-item":"NPhs6G","labelItem":"NPhs6G"};